import styled from 'styled-components';

export const StyledTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PageTitle = styled.h1`
  flex: 1;
  font-size: 18px;
  color: #444;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
